import styled, { css } from "styled-components";
import { Row, Button, Icon, Divider, Table, Checkbox, Select ,Input, Radio } from "antd";
const { TextArea } = Input;


const fontCommonStyle = css`
  font-family: HelveticaNeue;
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
`;

export const Spinner = styled.div`
  top: -14px;
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
  :before,
  :after {
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation: load7 1.8s infinite ease-in-out;
    animation: load7 1.8s infinite ease-in-out;
  }
  color: ${props => props.theme.fontColors.white};
  font-size: 6px;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;

  :before,
  :after {
    content: '';
    position: absolute;
    top: 0;
  }
  :before {
    left: -3.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  :after {
    left: 3.5em;
  }
  @-webkit-keyframes load7 {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
  @keyframes load7 {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
`;


export const RadioButton = styled(Radio)`
  .ant-radio-inner:after {
    background-color: ${props => props.theme.backgroundColor.primaryColor};
    width: 10px;
    height: 10px;
    top: 4px;
    left: 4px;
  }
  .ant-radio-checked .ant-radio-inner {
    border-color: ${props => props.theme.border.csrPill};
  }
  .ant-radio-inner {
    width: 20px;
    height: 20px;
  }
  .ant-radio:hover .ant-radio-inner {
    border: 1px solid ${props => props.theme.border.csrPill};
  }
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.tbody};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
`;

/**
 * ErrorMessage for displaying error message below input field - extend it to your component for additional properties
 */
export const ErrorMessage = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.error};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const ErrFormItem = styled(ErrorMessage).attrs(props => ({
  className: "error-fields-ooa"
}))`
  ${fontCommonStyle}
  letter-spacing : ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.error};
  line-height : ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;


/**
 * CommonListWrapper to be wrapped over your ordered/unordered list [Bullet Styles]
 */
export const CommonListWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  width: 100%;
`;


/** 
 * Bullet styles list wrapper for Funding instructions in Contributions
*/
export const ContributionListWrapper = css`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.tertiary};
  color: ${props => props.theme.fontColors.textColor};
`;

export const SectionSubHeading = styled.div`
  margin-top: 1rem;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.25;
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (max-width: 767px) {
    line-height: ${props => props.theme.lineHeight.note};
  }
`;

export const HeaderDataWrapper = styled.div`
  position: relative;
  width: 100%; 
  cursor:pointer;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-grow: 1;
  max-width: 1440px;
  padding: ${props => props.theme.spacing.paddings.webPagesTop}
    ${props => props.theme.spacing.paddings.webPagesX} 0
    ${props => props.theme.spacing.paddings.webPagesX};
  width: 100%;
  padding: ${props => props.theme.spacing.paddings.webPagesTop}
    ${props => props.theme.spacing.paddings.webPagesX} 0
    ${props => props.theme.spacing.paddings.webPagesX};
  @media only screen and (min-width: 768px) and (max-width: 991.91px) {
    padding: ${props => props.theme.spacing.paddings.padPagesTop}
      ${props => props.theme.spacing.paddings.padPagesX} 0
      ${props => props.theme.spacing.paddings.padPagesX};
  }
  @media only screen and (max-width: 767px) {
    padding-right: ${props => props.theme.spacing.paddings.mobPagesX};
    padding-left: ${props => props.theme.spacing.paddings.mobPagesX};
  }
`;

export const FixedWidth = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  @media (max-width: 1440px) {
    padding-left: 25px;
    padding-right: 25px;
  }
  @media (max-width: 576px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const ActivityFixedWidth = styled(FixedWidth)`
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    max-width: 1112px;    
  }
  margin: 0;
  padding: 0;
  @media (max-width: 1440px) {
    padding: 0;
  }
  @media (max-width: 576px) {
    padding: 0;
  }
`;

export const RoutesContainer = styled.div`
  margin-top: ${props => props.headerHeight !== null ? 160 + props.headerHeight : document.getElementById('tourContainer') ? 181 : 142}px;
  @media only screen and (max-width: 990px) {
    margin-top: ${props => props.headerHeight !== null ? 230 + props.headerHeight : document.getElementById('tourContainer') ? 245 : 160}px;
  }
  @media only screen and (max-width: 576px) {
    margin-top: ${props => props.headerHeight !== null ? 230 + props.headerHeight : document.getElementById('tourContainer') ? 245 : 160}px;
  }
`;

export const DisplayFlex = styled.div`
  display: flex;
  ${({ center }) => (center && `align-items:center`)}
  ${({ pos }) => (pos && `justify-content:${pos}`)}
`;

export const DisplayFlexGrant = styled(DisplayFlex)`
  justify-content: space-between;
`;

export const JustifyBetween = styled(DisplayFlex)`
  justify-content: space-between;
`;

export const JustifyAround = styled(DisplayFlex)`
  justify-content: space-around;
`;

export const AlignItemsCenter = styled(DisplayFlex)`
  align-items: center;
`;

export const CommonCard = styled.div`
  border: 1px solid ${props => props.theme.border.primary};
  background-color: ${props => props.theme.colors.white};
`;

export const GreyBackgroundSection = styled.div`
  background-color: ${props => props.theme.backgroundColor.layoutDark};
  padding: 50px 0px;
  @media only screen and (max-width: 1023px) {
    padding: 20px 0px;
  }
  @media only screen and (max-width: 576px) {
    padding: 20px 0px;
  }
`;

export const PagesHeading = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.investOnly ? props.theme.fontSize.h2 : props.theme.fontSize.h1};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h1};
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  margin-bottom:${props => props.marginBottom ? props.marginBottom : '0px'};
  word-break: break-word;
  -ms-word-wrap: break-word;
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h2};
    line-height: ${props => props.theme.lineHeight.h2};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h2};
    word-break: break-word;
    -ms-word-wrap: break-word;
  }
`;

export const SectionHeading = styled.h2`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h2};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h2};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h3};
    line-height: ${props => props.theme.lineHeight.h3};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h3};
    line-height: ${props => props.theme.lineHeight.h3};
  }
`;

export const SectionContent = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
font-weight: ${props => props.theme.fontWeight.normal};
font-style: normal;
font-stretch: ${props => props.theme.fontStretch.normal};
line-height: ${props => props.theme.lineHeight.primary};
letter-spacing: normal;
text-align: center;
color: ${props => props.theme.fontColors.textColor};
padding-bottom:1.875rem;
@media (min-width: 320px) and (max-width: 768px){
    font-size: ${props => props.theme.fontSize.secondary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
}
`

export const InvestmentDashboardBody = styled.div`
  margin-bottom: -24px;
`;

export const IDSectionHeading = styled(SectionHeading)`
  margin-bottom: 54px;
  @media only screen and (max-width: 576px) {
    margin-bottom: 42px;
  }
`;

export const SectionTopHeading = styled.h1`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.textColor};
  margin-top: 2.813rem;
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const SectionLastHeading = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.heading};
  }
`;
export const SectionLastHeadingH2 = styled.h2`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.heading};
  }
`;

export const LinkNavigator = styled.a`
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  font-size: ${props => props.theme.fontSize.primary} !important;
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.heading};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.primaryColor};
  text-transform: uppercase;
  &:hover {
    color: ${props => props.theme.colors.primaryColor};
  }
  @media only screen and (max-width: 990px) {
    display: flex;
    justify-content: ${props => props.tabNavigation ? 'center' : null};
    margin: ${props => props.tabNavigation ? '16px 0 !important' : null};
    font-size: ${props =>
    props.tabRedirect
      ? props.theme.fontSize.primary
      : props.theme.fontSize.tertiary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const PrimaryButtonComponent = styled(Button)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  background-color: ${props => props.theme.colors.primaryColor};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.colors.white};
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  border: none;
  border-radius: 0px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  height: 50px;
  opacity: ${props => (props.opacity ? props.opacity : "1")};
  border: ${props => props.borderEffect};
  width: ${props => (props.width ? props.width : "100%")};
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.primaryColor};
    color: ${props => props.theme.colors.white};
    border: ${props => props.borderHover};
    border-color: ${props => props.theme.colors.primaryColor};
  }
  &[disabled] {
    background-color: ${props => props.theme.backgroundColor.summaryDivider};
    border-color: ${props => props.theme.border.pill};
    color: ${props => props.theme.fontColors.textColor};
    opacity: 0.5;
  }
  &[disabled]:hover , &[disabled]:focus {
    opacity: ${props => (props.opacity ? props.opacity : "1")};
    background-color: ${props => props.theme.backgroundColor.summaryDivider};
    border-color: ${props => props.theme.border.pill};
    color: ${props => props.theme.fontColors.textColor};
  }
  @media only screen and (max-width: 990px) {
    width: 100%;
  }
`;

export const PrimaryButtonDisabled = styled(Button)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  background-color: ${props => props.theme.colors.primaryColor};
  font-size: ${props => props.theme.fontSize.heading};
  color: ${props => props.theme.colors.white};
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  border-radius: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  height: 50px;
  opacity: ${props => (props.opacity ? props.opacity : "1")};
  border: 0;
  width: ${props => (props.width ? props.width : "100%")};
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.primaryColor};
    color: ${props => props.theme.colors.white};
    border: 0;
  }
  &[disabled] {
    opacity: ${props => (props.opacity ? props.opacity : "1")};
    background-color: ${props => props.theme.backgroundColor.summaryDivider};
    border-color: ${props => props.theme.border.pill};
    color: ${props => props.theme.fontColors.textColor};
  }
  &[disabled]:hover , &[disabled]:focus {
    opacity: ${props => (props.opacity ? props.opacity : "1")};
    background-color: ${props => props.theme.backgroundColor.summaryDivider};
    border-color: ${props => props.theme.border.pill};
    color: ${props => props.theme.fontColors.textColor};
  }
  @media only screen and (max-width: 990px) {
    width: 100%;
  }
`;

export const GhostButtonComponent = styled(Button)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  background-color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.colors.primaryColor};
  border: 1px solid ${props => props.theme.colors.primaryColor};
  border-radius: 0px !important;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  ${props => (props.mt && `margin-top: ${props.mt}`)}
  height: 50px;
  width: ${props => (props.width ? props.width : "100%")};
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.primaryColor};
    border: 1px solid ${props => props.theme.colors.primaryColor};
  }
  @media only screen and (max-width: 990px) {
    width: 100%;
  }
`;

export const GhostBackButtonComponent = styled(Button)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  background-color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.colors.primaryColor};
  border: 1px solid ${props => props.theme.colors.primaryColor};
  border-radius: 0px !important;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  height: 50px;
  width: ${props => (props.width ? props.width : "100%")};
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.white};
    color: 1px solid ${props => props.theme.colors.primaryColor};
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.tertiary};
    line-height: ${props => props.theme.lineHeight.secondary};
    width: 100%;
  }
`;

export const SecondaryButtonComponentForLightText = styled(Button)`
  height: 30px;
  width: 100%;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  background-color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.colors.primaryColor};
  border: 1px solid ${props => props.theme.colors.border};
  font-stretch: ${props => props.theme.fontStretch.normal};
  border-radius: 18px;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.primaryColor};
    border: 1px solid ${props => props.theme.colors.border};
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const SecondaryButtonComponent = styled(Button)`
  height: 30px;
  width: 100%;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  background-color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.colors.primaryColor};
  border: 1px solid ${props => props.theme.colors.border};
  font-stretch: ${props => props.theme.fontStretch.normal};
  border-radius: 18px;
  font-style: normal;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.primaryColor};
    border: 1px solid ${props => props.theme.colors.border};
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
    &&.myProfileAccountDetailToggleBtn span {
      letter-spacing: ${props => props.theme.letterSpacing.zero};
      font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
    }
  }
`;

export const SectionLabel = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.thead};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.tertiary};
    line-height: ${props => props.theme.lineHeight.tertiary};
  }
`;

export const StepFlexRow = styled(Row)`
  display: flex;
  margin-top: 20px;
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
  }
`;

export const PillButton = styled(Button)`
  &&& {
    height: 1.75rem;
    border-radius: 18px;
    box-shadow: 0;
  }
`;

export const PrimaryIndicator = styled.div`
  width: 67px;
  padding: 2px 0 0 0;
  text-align: center;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.quaternary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  color: ${props => props.theme.colors.primaryColor};
  border: 1px solid ${props => props.theme.colors.primaryColor};
  text-transform: uppercase;
`;

export const UnderlineLink = styled.a`
  font-family: ${props => props.weight==="normal"? props.theme.fontFamily.berkeleyStdMedium : props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.h5};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h5};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.primary} !important;
  text-decoration: ${props => props.noDecaration ? 'none' : 'underline'};
  pointer-events: ${props => props.noDecaration ? 'none' : 'all'};
  &:hover :focus {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  a {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
  @media only screen and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.heading};
    line-height: ${props => props.theme.lineHeight.heading};
  }
`;

export const ParagraphAnchorTypeWithoutLink = styled.p`
  font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.h5};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h5};
  color: ${props => props.theme.fontColors.primary} !important;
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
`;

export const DataHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const DataValue = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  word-break: ${props => props.isWordBreak ? 'break-word' : 'normal'};
  @media only screen and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const DataValueColorNavy = styled(DataValue)`
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: unset;
  word-break: ${props => props.isBreak ? 'break-word' : 'normal'};
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    word-break: ${props => props.isBreak ? 'break-all' : 'normal'};
  }
`;

export const ItalicData = styled(DataValue)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-style: italic !important;
  font-weight: normal !important;
`;

export const WordBreakDataValue = styled(DataValue)`
    word-break: break-all !important;
`;

export const InvestmentOption = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  color: ${props => props.theme.fontColors.textColor};
  &:hover {
    color: ${props => props.theme.fontColors.textColor};
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const SummaryLabel = styled.div`
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.themeColor ? props.themeColor : props.theme.fontColors.summaryLabel};
  line-height: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  word-break: ${props => props.isWordBreak ? 'break-word' : 'normal'};
  @media only screen and (max-width: 797px) {
   margin-bottom: ${props => props.accountWrapper ? '10px' : '0'};
   word-break: ${props => props.accountWrapper || props.isWordBreak ? 'break-word': 'normal'};
   /* need to implement word break for IE */
  }
  @media only screen and (max-width: 991.92px) {
    font-size: ${props => props.theme.fontSize.secondary};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    word-break: ${props => props => props.accountWrapper || props.isWordBreak ? 'break-all' : 'normal'};
  }
`;

export const SummaryData = styled.div`
  font-size: ${props => props.theme.fontSize.h4};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.themeColor ? props.themeColor : props.theme.fontColors.summaryLabel};
  line-height: ${props => props.theme.lineHeight.oneP25};
  max-width: 350px;
  @media only screen and (max-width: 991.92px) {
    font-size: ${props => props.theme.fontSize.h5};
  }
`;

export const MandatoryAsterixSpan = styled.span`
  color: ${props => props.theme.colors.primary};
  margin-left: 0.25rem;
`;

export const GeminiViewContainer = styled.div`
  background-color: #fff1d0;
  padding: 10px;
  display: flex;
`;

export const BlurContainer = styled.div`
  position: relative;
  opacity: ${props => (props.isEnabled ? 1 : props.theme.backgroundColor.blur)};
`;

export const BlurOverlay = styled.div`
  display: none;
  position: absolute;
  height: 100%;
  width: 100%;
  ${props =>
    !props.isEnabled &&
    `display: block;
  z-index: 100;
  background-color: ${props.theme.backgroundColor.layoutLight};
  opacity: ${props.theme.backgroundColor.blurOpacity}`};
`;

export const RecurringIcon = styled(Icon)`
  margin-left: 1.25rem;
  cursor: auto;
  @media only screen and (max-width: 990px) {
    margin-left: 0.625rem !important;
  }
`;

export const SemiDarkerDivider = styled(Divider)`
  border-bottom: 1px solid ${props => props.theme.border.pill};
`;

export const DarkerDivider = styled(Divider)`
  border-bottom: 2px solid ${props => props.theme.border.divider};
`;

export const SectionDivider = styled(Divider)`
  margin: 50px 0 50px 0;
  @media (max-width: 576px) {
    margin: 40px 0 40px 0;
  }
`;

export const WhiteGradient = styled.div`
  width: 95%;
  height: 9%;
  position: absolute;
  bottom: 0;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
`;

export const SmallerWhiteGradient = styled.div`
  width: 95%;
  height: 7%;
  position: absolute;
  bottom: 0;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
`;

export const SectionSpacing = styled.div`
  margin-top: 3rem;
  margin-bottom: 3rem;
`;
export const SectionSpacingTable = styled.div`
  margin-bottom: 3rem;
`;

export const PagePrimaryNumber = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.h2};
  color: ${props => props.theme.fontColors.primary};
  font-weight: 300;
  @media only screen and (max-width: 991.92px) {
    font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
    font-size: ${props => props.theme.fontSize.h2};
  }
`;

export const PageSectionHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: normal;
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h4};
    line-height: ${props => props.theme.lineHeight.heading}; 
  }
`;

export const CommonTable = styled(Table)`
  .ant-table-fixed-header {
    .ant-table-scroll {
      .ant-table-header {
        padding-bottom: 0px !important;
        margin-bottom: -6px !important;
        background: ${props => props.theme.backgroundColor.layoutLight};
      }
      border-width: 0px 1px 1px 1px !important;
      ${noBorder => noBorder ? `border-style: solid !important;` : `border-style: none;`}
      border-color: ${props => props.theme.border.primary} !important;
    }
  }
  .ant-table-thead {
    tr {
      th { 
        padding: 10px 16px;
        background: ${props => props.theme.backgroundColor.layoutLight} !important;
        font-family: ${props => props.theme.fontFamily.helveticaNeueBold} !important;
        font-size: ${props => props.theme.fontSize.tableFont} !important;
        font-weight: ${props => props.theme.fontWeight.normal} !important;
        font-style: normal !important;
        font-stretch: ${props => props.theme.fontStretch.normal} !important;
        letter-spacing: ${props => props.theme.letterSpacing.zero} !important;
        color: ${props => props.theme.fontColors.headingColor} !important;
        .ant-table-column-sorter {
          transform: translate(0px, 0px);
          display: inline-block;
          vertical-align: middle;
          position: absolute; 
          left: 2px;
        }
        .ant-table-column-sorter .ant-table-column-sorter-inner {
          margin-left: 0px;
        }
        .ant-table-header-column .ant-table-column-sorters {
          display: flex;
        }
        border-bottom-width: 1px !important;
        border-bottom-style: solid !important;
        border-bottom-color: ${props => props.theme.border.primary} !important;
      }
      .ant-table-column-title {
        display: initial !important;
        transform: translate(0px, 0px) !important;  
      }
      border-bottom-width: 1px !important;
      border-bottom-style: solid !important;
      border-bottom-color: ${props => props.theme.border.primary} !important;
      border-top-width: 1px !important;
      border-top-style: solid !important;
      border-top-color: ${props => props.theme.border.primary} !important;
    }
  }
  .ant-table-tbody > tr > td{
    padding: 10px 16px;
    font-family: ${props => props.theme.fontFamily.helveticaNeue} !important;
    font-size: ${props => props.theme.fontSize.tableFont} !important;
    font-weight: ${props => props.theme.fontWeight.normal} !important;
    font-style: normal !important;
    font-stretch: ${props => props.theme.fontStretch.normal} !important;
    line-height: ${props => props.theme.lineHeight.tableFont} !important;
    letter-spacing: ${props => props.theme.letterSpacing.zero} !important;
    color: ${props => props.theme.fontColors.thead} !important;
    border-bottom-width: 1px !important;
    border-bottom-style: solid !important;
    border-bottom-color: ${props => props.theme.border.primary} !important;
    border-top-width: 1px !important;
    border-top-style: solid !important;
    border-top-color: ${props => props.theme.border.primary} !important;
  }
  .ant-table-row:nth-child(2n+1) {
    background-color: ${props => props.theme.backgroundColor.tableAltRowDark} ;
  }
`;
export const AccountNameWrapper = styled.div`
  width: 100%
`;

export const LinkTo = styled.a`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  word-break: break-all;
  display: inline-block;
  &.disable-hyperlink {
    color: rgba(80, 80, 80, 0.5)!important;
    pointer-events: none;
  }
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;

export const NoData = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  color: ${props => props.theme.fontColors.textColor};

  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;

export const NoDataDiv = styled.div`
  text-align: center;
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 576px) {
    height: 60px;
  }
`;

export const StyleLessButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;



export const Err = styled.div`
  position: relative;
  padding-bottom: 10px;
  padding-top: 30px;
  margin-top: -20px;
  ${fontCommonStyle}
  color: ${props => props.theme.fontColors.error};
  line-height: 1.25;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const InputWrapper = styled.div`
  input,
  .ant-select-selection--single {
    height: ${props => props.height ? props.height: '40px !important'};
  }

  .ant-select-arrow-icon {
    display: none;
  }

  input::placeholder {
    color: ${props => props.theme.colors.border};
  }

  .ant-select-selection {
    border-radius: 0;
    display: flex;
    align-items: center;
    border: 1px solid ${props => props.theme.colors.border};
  }

  .ant-input {
    border-radius: 0;
    color: ${props => props.theme.fontColors.textColor};
    font-size: ${props => props.theme.fontSize.primary};
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  .ant-input.has-error:hover {
    border: 1px solid ${props => props.theme.colors.border} !important;
  }

  .ant-calendar-picker-input {
    margin-top: 0 !important;
  }
`;

export const LabelWrapper = styled.div`
  ${fontCommonStyle}
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  line-height: ${props => props.theme.lineHeight.primary};
  margin-bottom: 4px;
  margin-top: 34px;
  content: none;
`;
export const RowWrapper = styled(Row)`
  /* margin-top: 6px; */
`;

export const PhoneLabelWrap = styled(LabelWrapper)`
  margin-top: 10px;
  margin-bottom: 4px;
`;
const titleCommmon = css`
  ${fontCommonStyle}
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal}; `

export const TitleWrapper = styled.div`
  ${titleCommmon}
  line-height:${props => props.theme.lineHeight.primary};
  letter-spacing : ${props => props.theme.letterSpacing.zero};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const CheckWrap = styled.span`
  ${fontCommonStyle}
  font-size: ${props => props.theme.fontSize.tertiary} !important;
  line-height: ${props => props.theme.lineHeight.primary} !important;
`;


export const WrapLabel = styled.div`
  &&& {
    .ant-form-item-label {
      margin-bottom: 10px;
    }
  }
  &&& {
    .ant-form-item-label > label::after {
      margin: 0;
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    &&& {
      .ant-form-item-label {
        padding: 0;
      }
    }
  }
`;

export const TitleMarginTop = styled.div`
  margin-top: 16px;
`;

export const ErrLength = styled(Err)`
  width: 60%;
  margin-top: -20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 231px;
  }
`;

export const DataId = styled(DataHeading)`
  font-weight: ${props => props.theme.fontWeight.bold};
`;

export const DataDescription = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.normal};
  color: ${props => props.theme.fontColors.textColor};
  margin: 12px 0 0 0;
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;
export const InvestmentPerformanceWrapper = styled.div`
  display: flex;
  position: relative;
  @media only screen and (max-width: 576px) {
    flex-direction: column;
  }
`;
export const MarketMovementWrapper = styled.div`
  position: absolute;
  right: 1.7%;

  @media only screen and (max-width: 990px) {
  }
  @media only screen and (max-width: 576px) {
    left: 0px;
    top: 38px;
  }
`;
export const MarketMovementTitle = styled.span`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.textColor};
`;
export const MarketMovementValue = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};  
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.headingColor};
`;

export const ErrorMsg = styled.div.attrs(()=>({
  className: "error-fields"
  }))`  
  margin-top: 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  font-weight: normal;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.error};
  visibility: ${props => props.visible};
  @media(max-width: 576px){
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;


export const InfoMsg = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  color: ${props => props.theme.fontColors.textColor};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
`;

export const TabFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 991px) {
    display: block;
  }
`;

export const NotifyText = styled.span`
  margin-right: ${props => props.noMargin ? '0' : '2rem'};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (max-width: 991px) {
    display: flex;
    justify-content: center;
    margin: ${props => props.theme.spacing.paddings.webBase} auto;
    text-align: center;
    font-size: 14px;
  }
`;

export const CustomCheckbox = styled(Checkbox)`
  span{
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
    color:${props => !props.disableColor && props.theme.fontColors.textColor};
    @media(max-width: 576px){
      font-size: ${props => props.theme.fontSize.secondary};
      line-height: ${props => props.theme.lineHeight.secondary};
    }
  }
  .ant-checkbox {
    .ant-checkbox-inner {
      height: 18px;
      width: 18px;
      border-radius: 0;
      border-width: 1.5px;
      border-color: ${props => props.theme.border.unchecked};
      background-color: ${props => props.theme.backgroundColor.layoutLight};
      &::after {
        border-color: ${props => props.theme.colors.primaryColor};
        left: 27%;
        height: 7px;
        width: 4px;
      }
    }
    &.ant-checkbox-checked {
      .ant-checkbox-inner {
        border-color: ${props => props.theme.colors.primaryColor};
      }
    }
  }
`;

export const CustomSelectBox = styled(Select)`
 font-family: ${props => props.theme.fontFamily.helveticaNeue};
 font-size: ${props => props.theme.fontSize.secondary};
 @media (min-width: 320px) and (max-width: 768px){
  font-size: ${props => props.theme.fontSize.tertiary};
    width: 100% !important;
  }
  @media only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2)  and (orientation: portrait)  {
    width:280px;
  }

  .ant-select-selection--multiple .ant-select-selection__choice{
    color: ${props => props.theme.fontColors.textColor};
  }
  //Select box hover and focus state
  .ant-select-selection{
    border-radius: 0px !important;
    box-shadow: 0 0 0 0 ${props => props.theme.border.pill} !important;
    &:focus{
      outline-color: ${props => props.theme.border.inputBox} !important;
      outline-width: 1px;
      box-shadow: 0 0 0 0 ${props => props.theme.border.inputBox} !important;
    }
  }

  //select box dimensions
  .ant-select-selection--single{
    height: 40px;
    width: ${props => props.width ? `${props.width}px` : "100%"} !important;
    @media(max-width: 767px){
      width: 100% !important;
    }
    //select box arrow
    .ant-select-arrow{
      top: 0;
      padding: 14px 13px;
      background-color: ${props => props.theme.backgroundColor.pill};
      margin: 0px;
      right: 0;
      bottom: 0;
    }

    .ant-select-selection__rendered{
      //select box selected value
      .ant-select-selection-selected-value{
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        font-size: ${props => props.theme.fontSize.secondary};
        font-weight: ${props => props.theme.fontWeight.normal};
        font-style: normal;
        font-stretch: ${props => props.theme.fontStretch.normal};
        line-height: ${props => props.theme.lineHeight.primary} !important;
        color: ${props => props.theme.fontColors.textColor};
        white-space: nowrap;
        width: ${props => props.width ? `${props.width - 50}px` : "90%"};
        overflow: hidden;
        text-overflow: ellipsis;
        @media(max-width: 767px){
          font-size:${props => props.theme.fontSize.tertiary} !important;
          line-height: ${props => props.theme.lineHeight.h3} !important;
        }
      }
    }
  }

  //for multi select items
  .ant-select-selection--multiple {
    border-top-width: 0px;
    border: 1px solid ${props => props.theme.border.pill};
    padding-bottom: 0px !important;
    .ant-select-selection__rendered{
      height: 41px;
      width: ${props => props.width ? `${props.width}px` : "100%"} !important;
      margin-right: 40px !important;
      margin-left: 12px !important;
      margin-bottom: 0px !important;
      @media(max-width: 767px){
        width: calc(100% - 35px) !important;
        margin-left: 8px !important;
      }
      ul {
        li {
          height: 24px;
          margin-top: 8px !important;
          line-height: 24px !important;
          &:last-child{
            margin-right: 0px !important;
            margin-bottom: 8px !important;
            @media(max-width: 767px){
              margin-right: 5px !important;
            }
          }
        }
      }
    }
  }
  //select box arrow
  .ant-select-arrow{
    top: 0;
    padding: 14px 13px;
    background-color: ${props => props.theme.backgroundColor.pill};
    margin: 1px;
    right: 0;
    bottom: 0;
  }
  //placeholder
  .ant-select-selection__placeholder, .ant-select-search__field__placeholder{
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    font-weight: ${props => props.theme.fontWeight.normal};
    font-style: normal;
    font-stretch: ${props => props.theme.fontStretch.normal};
    line-height: ${props => props.theme.lineHeight.primary} !important;
    color: ${props => props.theme.fontColors.placeholder};
    white-space: nowrap;
    width: ${props => props.width ? `${props.width - 5}px` : "90%"};
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left: 0px !important;
    @media(max-width: 768px){
      font-size: ${props => props.theme.fontSize.secondary}  !important;
      line-height: ${props => props.theme.lineHeight.secondary} !important;  
    }
  }
`;

export const TabMaskedDiv = styled.div`
  width: 98%;
  height: 26%;
  position: absolute;
  bottom: 0;
  z-index: 2;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  margin-bottom: 1px;
`;
export const ContentDiv = styled.div`
  ul {
    margin-bottom: 0px;
  }
  a{
    color: ${props => props.theme.border.teal};
    text-decoration: underline;
    cursor: pointer;
  }
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;
export const TitleTextWrapper = styled.div`
  margin-top: 16px;
  white-space:normal;
  width: 98%;
`;

/* global tooltip detach for purpose fields */
export const UnderlinePurpose = styled.span`
  font-weight: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline;
  cursor: ${props=> props.showCursor ? 'pointer' : 'normal'};
  font-size: ${props => props.theme.fontSize.primary};
  word-break: ${props => props.break ? 'normal' : 'break-word'};
`;

export const DataValueWrapper = styled.span`
  position: relative;
  &:hover ~ div,
  &:hover > div {
    display: block;
  }
`;

export const PointerTriangle = styled.div`
  position: absolute;
  width: 0!important;
  height: 0;
  border-left: 6px solid transparent;
  border-bottom: 7px solid ${props => props.theme.backgroundColor.boxToolTip};
  border-right: 6px solid transparent;
  top: -7px;
  left: 30%;
  @media only screen and (min-width: 320px) and (max-width: 523px) {
    left: 16%;
  }
`;

export const Content = styled.div`
  display: none;
  position: absolute;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  backdrop-filter: blur(2px);
  box-shadow: 5px 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: ${props => props.theme.backgroundColor.boxToolTip};
  padding: 12px 20px;
  font-size: ${props => props.theme.fontSize.secondary};
  color: ${props => props.theme.colors.white};
  border-radius: 4px;
  z-index: 102;
  margin-top: 7px;
  left: -26px;
  width: 250px;
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    left: -9px;
  }
`;

export const Editor = styled.div`
`;

export const PrintTable = styled(Table)`
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .ant-table-thead {
      vertical-align: top;
    }
    .ant-table-thead tr th {
      font-weight: 700;
    }
    .ant-table-thead tr th, .ant-table-tbody > tr > td {
      padding: 15px 5px;
      font-size: ${props => props.theme.fontSize.secondary} !important;
      width: ${props => props.width ? props.width+'%': '60px'};
      word-wrap: break-word !important;
    }
  }
`;
export const SliderMainHeader = styled.span`
  @media only screen and (max-width: 991px) {
    letter-spacing: ${props => props.theme.letterSpacing.normal} !important;
    &&.updatePassword, &&.changeSecurityQuestion {
      line-height: ${props => props.theme.lineHeight.h3};
      font-size: ${props => props.theme.fontSize.h3};
    }
  }
`;

export const EllipsisUnderline = styled.span`
font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: ${props => props.theme.letterSpacing.normal};  
  text-decoration: underline;
  cursor: pointer;  
  overflow: hidden !important;
  width:170px;
  text-overflow:ellipsis !important;
  display: inline-block !important;	
  word-break: normal !important;
  white-space: nowrap;
  vertical-align: bottom;
  margin: 0;
  padding: 0;
  @media screen and (min-color-index:0) and(-webkit-min-device-pixel-ratio:0)
  { 
    &::before, 
      &::after {
        content: '';
        display: block;
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 380px) {
    max-width:120px;
  }
`;

export const EllipsisDataValueWrapper = styled.span`
  position: relative;
  &:hover ~ div,
  &:hover > div {
    display: block;
  }
`;

export const EllipsisPointer = styled.div`
  position: absolute;
  width: 0!important;
  height: 0;
  border-left: 6px solid transparent;
  border-bottom: 7px solid ${props => props.theme.backgroundColor.boxToolTip};
  border-right: 6px solid transparent;
  top: -7px;
  left: 10%;
  @media only screen and (min-width: 320px) and (max-width: 523px) {
    left: 10%;
  }
`;

export const EllipsisContent = styled.div`
  display: none;
  position: absolute;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  backdrop-filter: blur(2px);
  box-shadow: 5px 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: ${props => props.theme.backgroundColor.boxToolTip};
  padding: 12px 20px;
  font-size: ${props => props.theme.fontSize.secondary};
  color: ${props => props.theme.colors.white};
  border-radius: 4px;
  z-index: 102;
  margin-top: 7px;
  left: 0px;
  width: 215px;
  word-break: break-all;
  margin-bottom:30px;
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    left: -9px;
  }
`;
export const AdvisorWrapper = styled.span`
  @media only screen and (max-width: 991px) {
    font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
    font-size: ${props => props.theme.fontSize.primary} !important;
  }
`;

export const MenuContentWrapper = styled.div`
  width: 100%;
  padding: 0px 20px;
  &:hover, &:active {
    background: ${props => props.theme.backgroundColor.menuSelection};
  }
`
export const MobileViewWrapper = styled.div`
  width: 100%;
`;

export const GeneralCustomDiv = styled.div`
  & button {
    ${(props) => props.prfShowMore && `width: 100%`};
  }
`;

export const InputField = styled(Input)`
  height: 40px;
  border-radius: 0px;
  width: ${props => !props.width ? null : props.type==="long" ? '631px': '300px'};
  max-width:${props => !props.width ? null : props.type==="long" ? '631px': '300px'};
  margin: 0px 0px 6px 0px;
  padding: 11px 20px 11px 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary} ;
  letter-spacing:  ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.textColor};
  :focus {
    background-color: layoutLight;
  }
  @media only screen and (max-width: 991px) {
    width: 100%;
    max-width: ${props => !props.width ? null : '316px' };
    margin: 0px 0px 6px 0px;
  }
   @media only screen and (max-width: 360px) {
    width: 100%;
    max-width: ${props => !props.width ? null : '300px' };
    margin: 0px 0px 6px 0px;
  }
`;

export const InputTextAreaField = styled(TextArea)`
  height: ${props => props.height} !important;
  border-radius: 0px;
  resize: none;
  width: ${props => props.width};
  max-width: ${props => props.width};
  padding: 11px 20px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size:  ${props => props.theme.fontSize.primary} ;
  letter-spacing:  ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (max-width: 560px) {
    height: 100px !important;
    width: 100%;
    max-width:316px;
  }
   @media only screen and (max-width: 360px) {
    height: 100px !important;
    width: 100%;
    max-width:300px;
  }

`;

export const SearchInput = styled(Input)`
  width : ${props => props.width ? props.width : 'auto'};
  height : ${props => props.height ? props.height : 'auto'};
  & .ant-input {
    border-radius: unset !important;
    color: ${props => props.theme.fontColors.summaryLabel};
    font-size: ${props => props.theme.fontSize.primary};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};

    &::placeholder {
      text-overflow: ${props => props.overflow ? 'ellipsis' : 'unset'};
    }
  }

  & .ant-input-suffix {
    top: ${props => props.iconTop ? props.iconTop : '50%' };
    cursor: pointer;
    right: ${props => props.iconRight ? props.iconRight : '12px'};
    & img {
      width: ${props => props.iconWidth ? props.iconWidth : '15px'};
      height: ${props => props.iconHeight ? props.iconHeight : '16px'};
    }
  }

  & input::placeholder {
    font-size: ${props => props.theme.fontSize.primary};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.fontColors.summaryLabel};
  }

  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    width: 100%;
  }
`;

export const TransactionCard = styled(Row)`
  width: 526px;
  background-color: ${props => props.theme.backgroundColor.cardDark};
  height: 96%;
  display: inline-block;
  padding: 22px;
  margin-right: 10px;
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    width: 100%;
  }
`;

export const TransactionCardMobile = styled(TransactionCard)`
  display: block;
  margin-right: 0;
  margin-bottom: 10px;
`;

export const TransactionName = styled(DataHeading)`
  display: inline-block;
  margin-top: 1.25rem;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  & b {
    color: ${props => props.theme.fontColors.headingColor};
  }
`;